import React, { Component } from 'react';

import './style.css';

export default class WorkCard extends Component {
  render() {
    const { data, bunc } = this.props;
    return (
      <div
        className='container content wow bounceInLeft'
        data-wow-duration='2s'
      >
        <div className='row'>
          <img src={data.img} alt='' className='logo col-md-2 col-3' />
          <div className='dataCont col-8'>
            <div className='positionCont'>
              {data.role} {bunc}{' '}
              <span className='companyName'>{data.company}</span>
            </div>
            <div className='periodCont text-muted'>
              <span className='form'>{` ${data.from} `}</span>
              <span className='gold'>-</span>
              <span className='to'>{` ${data.to} `}</span>
            </div>
            <div className='descCont'>{data.desc}</div>
          </div>
        </div>
      </div>
    );
  }
}
